import {MaltClassicCreationStepRoute, MaltStrategyCreationStepRoute} from '@/profile-creation-wizard/config/steps/ProfileCreationRoutes';

export function linkToMarketplace(currentStep: MaltStrategyCreationStepRoute): string {
    return window.location.href.replace(currentStep, MaltClassicCreationStepRoute.SIGNUP_HEADLINE);
}
